<template>
  <div class="page bg-white">
    <BindingMobile :telInput="telInput" @inputTelInfo="updTel" class="bg-white" style="margin-top:10px"></BindingMobile>
    <p class="note">请输入原账户绑定的手机号码并输入验证码完成账户关联。</p>

    <van-button
      color="#1E8DFF"
      @click="submit"
      class="submit-btn width-351"
      :disabled="!($util.isMobileValid(telInput.mobile) && $util.isMobileCodeValid(telInput.code))"
    >
      确定关联
    </van-button>
  </div>
</template>

<script>
import BindingMobile from '@/components/BindingMobile.vue';

export default {
  name: 'LinkMobile',
  components: {
    BindingMobile
  },
  data() {
    return {
      telInput: {
        mobile: '',
        code: ''
      }
    };
  },
  methods: {
    updTel(data) {
      if (data.type == 'mobile') {
        this.telInput.mobile = data.value;
      }
      if (data.type == 'code') {
        this.telInput.code = data.value;
      }
    },

    submit() {
      const { mobile, code } = this.telInput;
      if (mobile && code) {
        const params = {
          mobile,
          verifyCode: code,
          verifyCodeType: 'BIND_PATIENT_MOBILE'
        };
        this.$fetch.updMobile(params).then(data => {
          if (data.code == -102 || data.code == -106) {
            this.$router.push({ name: 'LinkSuccess' });
          }
          if (data.code == -107) {
            this.$router.push({ name: 'LinkFail' });
          }
        });
      } else {
        this.$toast('请将信息填写完整');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100%;
  .submit-btn {
    position: absolute;
    bottom: 32px;
    left: 0;
  }
}
.note {
  margin: 16px 12px 0;
  color: #999;
  line-height: 20px;
}
</style>
